<div class="mb-2 text-sm">
  <span class="font-semibold">Current phone number:</span>
  {{ currentPhoneNumber }}
</div>

<form [formGroup]="updatePhoneNumberForm" (ngSubmit)="submitHandler()">
  <app-shared-input
    label="New phone number"
    for="phoneNumber"
    [value]="updatePhoneNumberForm.value.phoneNumber"
    [focused]="focused"
    [touched]="updatePhoneNumberForm.get('phoneNumber')?.touched"
    [errors]="updatePhoneNumberForm.get('phoneNumber')?.errors"
    [disabled]="!!(loading$ | async)"
    prefix="+1"
  >
    <input
      formControlName="phoneNumber"
      name="phoneNumber"
      id="phoneNumber"
      type="tel"
      (paste)="pastePhoneNumberHandler($event)"
      (focus)="focused = true"
      (blur)="focused = false"
      mask="(000) 000-0000"
    />
  </app-shared-input>

  <app-shared-button size="small" [loading]="!!(loading$ | async)">
    Update Phone Number
  </app-shared-button>
</form>
